import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconService, IconDirective } from '@ant-design/icons-angular';
import {
  SettingOutline,
  UserOutline,
  BellOutline,
  MessageOutline,
  HomeOutline,
  FileTextOutline,
  BarChartOutline,
  TeamOutline,
  CloseOutline,
  PlusOutline,
  MinusOutline,
  AppstoreOutline,
  DatabaseOutline,
  SafetyOutline
} from '@ant-design/icons-angular/icons';

@Component({
  standalone: true,
  selector: 'app-settings-sidebar',
  imports: [CommonModule, IconDirective],
  templateUrl: './settings-sidebar.component.html',
  styleUrls: ['./settings-sidebar.component.scss']
})
export class SettingsSidebarComponent {
  private iconService = inject(IconService);
  
  isOpen = input<boolean>(false);
  closeSidebar = output();

  constructor() {
    this.iconService.addIcon(
      ...[
        SettingOutline,
        UserOutline,
        BellOutline,
        MessageOutline,
        HomeOutline,
        FileTextOutline,
        BarChartOutline,
        TeamOutline,
        CloseOutline,
        PlusOutline,
        MinusOutline,
        AppstoreOutline,
        DatabaseOutline,
        SafetyOutline
      ]
    );
  }

  shortcuts = [
    {
      icon: 'home',
      title: 'Dashboard',
      description: 'Go to main dashboard',
      type: 'item'
    },
    {
      icon: 'appstore',
      title: 'Applications',
      description: 'Manage applications',
      type: 'group',
      expanded: false,
      children: [
        {
          icon: 'user',
          title: 'User Management',
          description: 'Manage users',
          type: 'group',
          expanded: false,
          children: [
            { icon: 'user', title: 'All Users', description: 'View all users', type: 'item' },
            { icon: 'team', title: 'User Groups', description: 'Manage groups', type: 'item' }
          ]
        },
        {
          icon: 'bell',
          title: 'Notifications',
          description: 'Notification settings',
          type: 'item'
        }
      ]
    },
    {
      icon: 'database',
      title: 'Data Management',
      description: 'Manage data',
      type: 'group',
      expanded: false,
      children: [
        {
          icon: 'file-text',
          title: 'Documents',
          description: 'Document management',
          type: 'group',
          expanded: false,
          children: [
            { icon: 'file-text', title: 'Upload Files', description: 'Upload new files', type: 'item' },
            { icon: 'bar-chart', title: 'File Analytics', description: 'View file stats', type: 'item' }
          ]
        },
        {
          icon: 'message',
          title: 'Messages',
          description: 'View messages',
          type: 'item'
        }
      ]
    },
    {
      icon: 'setting',
      title: 'Settings',
      description: 'App settings',
      type: 'item'
    }
  ];

  onCloseSidebar() {
    this.closeSidebar.emit();
  }

  onShortcutClick(shortcut: any) {
    if (shortcut.type === 'group') {
      shortcut.expanded = !shortcut.expanded;
    } else {
      console.log('Shortcut clicked:', shortcut.title);
    }
  }

  toggleGroup(group: any) {
    group.expanded = !group.expanded;
  }
}